<mat-card class="sticky-header p-y-0" [style.background-color]="sharedService.blue">
  <mat-card-content>
    <div class="flex flex-row justify-start items-center gap-2">
      <mat-icon class="medium-icon m-6">description</mat-icon>
      <span class="f-s-20">{{editingApprovedCurriculum? "Edit" : "View"}} Approved Curriculum</span>
    </div>
  </mat-card-content>
</mat-card>

<div class="flex flex-col gap-4">
  <div class="flex flex-row justify-start items-center gap-4">
    <span class="f-s-20">Approved Curriculum</span>
    <button *ngIf="editingApprovedCurriculum && authService.isAdmin" type="button" mat-icon-button color="warn"
      matTooltip="Stop Editing" matTooltipShowDelay=800
      aria-label="Stop Editing" (click)="toggleEdit()">
      <mat-icon>edit_off</mat-icon>
    </button>
    <button *ngIf="!editingApprovedCurriculum && authService.isAdmin" type="button" mat-icon-button color="primary"
      matTooltip="Edit" matTooltipShowDelay=800 aria-label="Edit"
      (click)="toggleEdit()">
      <mat-icon>edit</mat-icon>
    </button>
  </div>

  <div *ngIf="editingApprovedCurriculum" class="flex flex-row justify-start items-center gap-4">
    <mat-form-field class="w-[30%]">
      <input matInput placeholder="New Curriculum" [(ngModel)]="newApprovedCurriculum" />
    </mat-form-field>
    <button type="button" mat-stroked-button color="primary" (click)="addCurriculum()">
      Add
    </button>
  </div>

  <mat-list *ngIf="approvedCurriculum.names.length > 0">
    <mat-list-item *ngFor="let name of approvedCurriculum.names; let i = index">
      {{i+1}}. {{ name }}
      <button *ngIf="editingApprovedCurriculum" mat-icon-button color="warn" (click)="removeCurriculum(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </mat-list-item>
  </mat-list>
</div>

<div *ngIf="sharedService.loading || loading">
  <div id="globalLoader" [ngClass]="{'global-loader': true, 'global-loader-dark': sharedService.darkMode}">
    <h1>Loading</h1>
  </div>
</div>
